import * as react from "react";
import { CSSProp, Prop, DOMAttr, HTMLAttr } from "../Bfs.Web.Kundenportal/fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { empty as empty_1, singleton as singleton_1, ofArray } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/List.js";
import { length, pairwise, ofList, map, concat, filter, sort, empty, singleton, append, delay, toList } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Seq.js";
import { value as value_1 } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Option.js";
import { keyValueList } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { root } from "../Bfs.Web.Kundenportal/fable_modules/Fulma.Elmish.1.0.0/DatePicker/View.fs.js";
import { german } from "../Bfs.Web.Kundenportal/fable_modules/Fable.Date.1.0.0/Date.Local.fs.js";
import { Config$1 } from "../Bfs.Web.Kundenportal/fable_modules/Fulma.Elmish.1.0.0/DatePicker/Types.fs.js";
import { distinct } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Seq2.js";
import { comparePrimitives, numberHash } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Util.js";
import { printf, toText } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/String.js";
import { Option, switch$ as switch$_1 } from "../Bfs.Web.Kundenportal/fable_modules/Fulma.Extensions.Wikiki.Switch.3.0.0/Switch.fs.js";
import { CustomColors_bfsOrange } from "./Helpers.fs.js";

export const spinner = (() => {
    const children = [react.createElement("img", {
        src: "spinner.gif",
        alt: "loading",
    })];
    return react.createElement("div", {
        className: "waiting",
    }, ...children);
})();

export const spinnerwhite = (() => {
    const children = [react.createElement("img", {
        src: "spinner-white.gif",
        alt: "loading",
    })];
    return react.createElement("div", {
        className: "waiting",
    }, ...children);
})();

export const nothing = react.createElement("div", {});

export function errorMsg(text) {
    return react.createElement("div", {
        className: "center-msg",
    }, text);
}

export function optionalErrorMsg(text) {
    if (text == null) {
        return react.createElement("div", {});
    }
    else {
        return errorMsg(text);
    }
}

function capslocklWarningAttribuntes(id, attribute) {
    return ofArray([new HTMLAttr(65, ["control is-tooltip-active is-tooltip-warning " + attribute]), ["data-tooltip", "Bitte beachten Sie, dass die   Feststelltaste gedrückt ist."], new DOMAttr(8, [(_arg) => {
        document.getElementById(id).classList.remove("tooltip");
    }]), new DOMAttr(17, [(ev) => {
        if (ev.getModifierState("CapsLock")) {
            document.getElementById(id).classList.add("tooltip");
        }
        else {
            document.getElementById(id).classList.remove("tooltip");
        }
    }])]);
}

function validatedInputBox(controlType, capslockWarning, withErrorText, attributes, onChange, caption, key, placeholder, field) {
    let props_6, children_4;
    const isDanger = (field.Error == null) ? "" : " is-danger ";
    const children_6 = [react.createElement("label", {
        className: "label",
    }, caption), (props_6 = toList(delay(() => append(singleton(new HTMLAttr(99, ["capslock" + key])), delay(() => ((capslockWarning != null) ? capslocklWarningAttribuntes("capslock" + key, value_1(capslockWarning)) : singleton(new HTMLAttr(65, ["control"]))))))), (children_4 = toList(delay(() => {
        let props_2;
        return append(singleton((props_2 = toList(delay(() => append(singleton(new HTMLAttr(65, ["input" + isDanger])), delay(() => append(singleton(new HTMLAttr(161, [field.Value])), delay(() => append(singleton(new HTMLAttr(159, [controlType])), delay(() => append(singleton(new Prop(0, [key])), delay(() => append(singleton(new HTMLAttr(123, [key])), delay(() => append(singleton(new HTMLAttr(128, [placeholder])), delay(() => append(singleton(new DOMAttr(9, [(ev) => {
            onChange(ev.target.value);
        }])), delay(() => attributes)))))))))))))))), react.createElement("input", keyValueList(props_2, 1)))), delay(() => {
            const matchValue_1 = field.Error;
            let matchResult;
            if (withErrorText) {
                if (matchValue_1 != null) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    const error = matchValue_1;
                    return singleton(react.createElement("span", {
                        className: "help is-danger",
                    }, error));
                }
                default: {
                    return empty();
                }
            }
        }));
    })), react.createElement("div", keyValueList(props_6, 1), ...children_4)))];
    return react.createElement("div", {
        className: "field",
    }, ...children_6);
}

export const validatedTextBox = (onChange) => ((caption) => ((key) => ((placeholder) => ((field) => validatedInputBox("text", undefined, true, [], onChange, caption, key, placeholder, field)))));

export function validatedTextBoxWithAttributes(attributes) {
    return (onChange) => ((caption) => ((key) => ((placeholder) => ((field) => validatedInputBox("text", undefined, true, attributes, onChange, caption, key, placeholder, field)))));
}

export const validatedTextBoxWithoutErrorMsg = (onChange) => ((caption) => ((key) => ((placeholder) => ((field) => validatedInputBox("text", undefined, false, [], onChange, caption, key, placeholder, field)))));

export function validatedTextBoxWithoutErrorMsg2(attributes) {
    return (onChange) => ((caption) => ((key) => ((placeholder) => ((field) => validatedInputBox("text", undefined, false, attributes, onChange, caption, key, placeholder, field)))));
}

export function validatedPasswordBoxWithoutErrorMsg(capslockTooltipAttribute, attributes) {
    return (onChange) => ((caption) => ((key) => ((placeholder) => ((field) => validatedInputBox("password", capslockTooltipAttribute, false, attributes, onChange, caption, key, placeholder, field)))));
}

export function validatedTextarea(onChange, caption, key, placeholder, additonalClasses, field) {
    let children_6;
    const isDanger = (field.Error == null) ? "" : " is-danger";
    const children_8 = [react.createElement("label", {
        className: "label",
    }, caption), (children_6 = toList(delay(() => {
        let props_2;
        return append(singleton((props_2 = [new HTMLAttr(65, [("textarea " + additonalClasses) + isDanger]), new HTMLAttr(159, ["text"]), new Prop(0, [key]), new HTMLAttr(123, [key]), new HTMLAttr(128, [placeholder]), new HTMLAttr(161, [field.Value]), new DOMAttr(9, [(ev) => {
            onChange(ev.target.value);
        }])], react.createElement("textarea", keyValueList(props_2, 1)))), delay(() => {
            const matchValue_1 = field.Error;
            if (matchValue_1 != null) {
                const error = matchValue_1;
                return singleton(react.createElement("span", {
                    className: "help is-danger",
                }, error));
            }
            else {
                return empty();
            }
        }));
    })), react.createElement("div", {
        className: "control",
    }, ...children_6))];
    return react.createElement("div", {
        className: "field",
    }, ...children_8);
}

export function validatedDatePicker(onChange, caption, field, dispatch) {
    let children_4;
    const isDanger = (field.Error == null) ? "" : " is-danger";
    const children_6 = [react.createElement("label", {
        className: "label",
    }, caption), (children_4 = toList(delay(() => append(singleton(root(new Config$1(onChange, german, ofArray([new CSSProp(291, ["absolute"]), new CSSProp(249, ["450px"])])), field.DatePickerState, field.Value, dispatch)), delay(() => {
        const matchValue_1 = field.Error;
        if (matchValue_1 != null) {
            const error = matchValue_1;
            return singleton(react.createElement("span", {
                className: "help is-danger",
            }, error));
        }
        else {
            return empty();
        }
    })))), react.createElement("div", {
        className: "control",
    }, ...children_4))];
    return react.createElement("div", {
        className: "field",
    }, ...children_6);
}

function cleanPages(count, pages) {
    return sort(distinct(filter((x) => {
        if (x >= 0) {
            return x <= count;
        }
        else {
            return false;
        }
    }, pages), {
        Equals: (x_1, y) => (x_1 === y),
        GetHashCode: numberHash,
    }), {
        Compare: comparePrimitives,
    });
}

function paginationAlways(page, onClick) {
    let children_8, pagesmall;
    const n = page.Page | 0;
    const count = page.PageCount | 0;
    const children_10 = [(children_8 = [Array.from(concat(map((tupledArg) => {
        const current = tupledArg[1] | 0;
        const active = (current === page.Page) ? singleton_1(new HTMLAttr(65, ["is-active"])) : empty_1();
        return toList(delay(() => append(((current - tupledArg[0]) > 1) ? singleton(react.createElement("span", {
            className: "pagination-ellipsis",
        }, "...")) : empty(), delay(() => {
            let props_6, children_6, children_4, children_2;
            return singleton((props_6 = ofList(active), (children_6 = [(children_4 = [(children_2 = [toText(printf("%i"))(current)], react.createElement("span", {}, ...children_2))], react.createElement("a", {
                onClick: (_arg) => {
                    onClick(current);
                },
            }, ...children_4))], react.createElement("li", keyValueList(props_6, 1), ...children_6))));
        }))));
    }, pairwise((window.matchMedia("(min-width: 450px)").matches) ? ((pagesmall = cleanPages(count, [0, 1, 2, n - 1, n, n + 1, count - 1, count]), (length(pagesmall) <= 6) ? cleanPages(count, append(pagesmall, [3, count - 2])) : pagesmall)) : cleanPages(count, [0, 1, n - 1, n, n + 1, count])))))], react.createElement("ul", {}, ...children_8))];
    return react.createElement("div", {
        className: "wishlist-pagination",
    }, ...children_10);
}

export function pagination(page, onClick) {
    if (page.PageCount > 1) {
        return paginationAlways(page, onClick);
    }
    else {
        return react.createElement("div", {});
    }
}

export function paginationR(page, onClick) {
    switch (page.tag) {
        case 1:
            return react.createElement("div", {});
        case 2:
            return react.createElement("div", {});
        case 3:
            return pagination(page.fields[0], onClick);
        default:
            return react.createElement("div", {});
    }
}

function icon2(spanclass, cssclass) {
    const children_2 = [react.createElement("i", {
        className: cssclass,
    })];
    return react.createElement("span", {
        className: spanclass,
    }, ...children_2);
}

export const icon = (cssclass) => icon2("icon", cssclass);

export const linkicon = (cssclass) => icon2("linkicon", cssclass);

export const newIndicator = react.createElement("div", {
    className: "new-item-wrapper",
});

export function adminImageUpload(id, hasImage, imageUrl, deleteMsg, uploadMsg, dispatch, notSavedText, notice) {
    let props;
    if (id == null) {
        return react.createElement("div", {}, notSavedText);
    }
    else if (hasImage) {
        const id_1 = value_1(id);
        const children_2 = [(props = [new HTMLAttr(149, [imageUrl(id_1)])], react.createElement("img", keyValueList(props, 1))), react.createElement("button", {
            className: "button is-danger is-small is-link",
            onClick: (_arg) => {
                dispatch(deleteMsg);
            },
        }, "Bild löschen")];
        return react.createElement("div", {
            className: "image-preview",
        }, ...children_2);
    }
    else {
        const id_2 = value_1(id);
        const xs = toList(delay(() => {
            let children_14, children_12, children_10, children_6;
            return append(singleton((children_14 = [(children_12 = [react.createElement("input", {
                className: "file-input",
                type: "file",
                accept: "image/jpeg",
                onChange: (ev) => {
                    dispatch(uploadMsg(ev.target.files[0]));
                },
            }), (children_10 = [(children_6 = [react.createElement("i", {
                className: "fas fa-upload",
            })], react.createElement("span", {
                className: "file-icon",
            }, ...children_6)), react.createElement("span", {
                className: "file-label",
            }, "Datei auswählen…")], react.createElement("span", {
                className: "file-cta",
            }, ...children_10))], react.createElement("label", {
                className: "file-label",
            }, ...children_12))], react.createElement("div", {
                className: "file is-boxed",
            }, ...children_14))), delay(() => {
                let children_18, children_16;
                return (notice != null) ? singleton((children_18 = [(children_16 = [value_1(notice)], react.createElement("i", {}, ...children_16))], react.createElement("div", {
                    className: "",
                }, ...children_18))) : empty();
            }));
        }));
        return react.createElement(react.Fragment, {}, ...xs);
    }
}

export function adminImageUploadBox(id, hasImage, imageUrl, deleteMsg, uploadMsg, dispatch, title, notSavedText) {
    let children_4, children_2, children_8, children_6;
    let notice;
    const Value = "Es dürfen nur jpg-Dateien hochgeladen werden, die die passende Auflösung und Größe für die Website haben! Eine Prüfung oder Konvertierung findet nicht statt.";
    notice = Value;
    const children_10 = [(children_4 = [(children_2 = [react.createElement("b", {}, title)], react.createElement("h3", {}, ...children_2))], react.createElement("div", {
        className: "card-title",
    }, ...children_4)), (children_8 = [(children_6 = [adminImageUpload(id, hasImage, imageUrl, deleteMsg, uploadMsg, dispatch, notSavedText, notice)], react.createElement("div", {
        className: "info-block",
    }, ...children_6))], react.createElement("div", {
        className: "card-body",
    }, ...children_8))];
    return react.createElement("div", {
        className: "flat-card profile-info-card is-auto",
    }, ...children_10);
}

export const Icons_Home = (() => {
    const children_2 = [react.createElement("path", {
        d: "M18.81,19.7H1.11a.83.83,0,0,1-.83-.83V7.44a.82.82,0,0,1,.35-.67L9.48.5a.83.83,0,0,1,1,0l8.85,6.27a.82.82,0,0,1,.35.67V18.88A.82.82,0,0,1,18.81,19.7ZM1.93,18H18V7.86L10,2.18l-8,5.68Z",
    })];
    return react.createElement("svg", {
        viewBox: "0 0 20 20",
    }, ...children_2);
})();

export const Icons_Settings = (() => {
    let children_4;
    const children_6 = [(children_4 = [react.createElement("path", {
        d: "M10,13.49A3.49,3.49,0,1,1,13.49,10,3.49,3.49,0,0,1,10,13.49ZM10,8a2,2,0,1,0,2,2A2,2,0,0,0,10,8Z",
    }), react.createElement("path", {
        d: "M10,19.65a2.53,2.53,0,0,1-2.5-2.2,7.83,7.83,0,0,1-1-.41A2.51,2.51,0,0,1,5,17.56H5A2.52,2.52,0,0,1,3,13.5a7.69,7.69,0,0,1-.41-1,2.52,2.52,0,0,1,0-5A7.87,7.87,0,0,1,3,6.5a2.52,2.52,0,0,1,.22-3.32A2.58,2.58,0,0,1,6.5,3a7.85,7.85,0,0,1,1-.41,2.52,2.52,0,0,1,5,0,7.7,7.7,0,0,1,1,.41,2.58,2.58,0,0,1,3.32.22A2.52,2.52,0,0,1,17,6.5a7.93,7.93,0,0,1,.41,1,2.52,2.52,0,0,1,0,5,7.78,7.78,0,0,1-.41,1,2.52,2.52,0,0,1-2,4.06h0A2.5,2.5,0,0,1,13.5,17a7.7,7.7,0,0,1-1,.41A2.53,2.53,0,0,1,10,19.65ZM6.35,15.37a.74.74,0,0,1,.38.11,6.34,6.34,0,0,0,1.7.71A.74.74,0,0,1,9,17l0,.14a1,1,0,0,0,2.08,0L11,17a.74.74,0,0,1,.55-.8,6.33,6.33,0,0,0,1.7-.71.74.74,0,0,1,1,.18l.12.18a1,1,0,0,0,.69.25h0a1,1,0,0,0,.74-1.78l-.12-.07a.74.74,0,0,1-.18-1,6.4,6.4,0,0,0,.71-1.7A.75.75,0,0,1,17,11l.13,0a1,1,0,0,0,1-1A1,1,0,0,0,17,9a.78.78,0,0,1-.86-.55,6.36,6.36,0,0,0-.71-1.7.74.74,0,0,1,.18-1l.18-.11a1.06,1.06,0,0,0-.06-1.42,1.07,1.07,0,0,0-1.47,0,1.1,1.1,0,0,1-.06.12.74.74,0,0,1-1,.18,6.3,6.3,0,0,0-1.69-.71A.74.74,0,0,1,11,3l0-.15A1,1,0,0,0,9,2.87L9,3a.74.74,0,0,1-.55.81,6.29,6.29,0,0,0-1.7.71.74.74,0,0,1-1-.18l-.11-.18a1.13,1.13,0,0,0-1.42.05,1,1,0,0,0,0,1.47l.12.06a.74.74,0,0,1,.18,1,6.35,6.35,0,0,0-.71,1.7A.74.74,0,0,1,3,9L2.87,9a1,1,0,1,0,0,2.08L3,11a.75.75,0,0,1,.81.55,6.39,6.39,0,0,0,.71,1.7.74.74,0,0,1-.18,1l-.18.11a1,1,0,0,0-.25.69,1,1,0,0,0,1,1H5a1,1,0,0,0,.74-.31,1.18,1.18,0,0,1,.07-.12A.74.74,0,0,1,6.35,15.37Z",
    })], react.createElement("g", {}, ...children_4))];
    return react.createElement("svg", {
        viewBox: "0 0 20 20",
    }, ...children_6);
})();

export function Icons_TicketSvg(customStyle) {
    const props_2 = [["viewBox", "0 0 20 20"], ["style", keyValueList(customStyle, 1)]];
    const children_2 = [react.createElement("path", {
        d: "M18.57,16.86H1.44a.74.74,0,0,1-.74-.74V12.58a.74.74,0,0,1,.74-.74,1.84,1.84,0,1,0,0-3.69A.74.74,0,0,1,.7,7.42V3.88a.74.74,0,0,1,.74-.73H18.57a.74.74,0,0,1,.74.73V7.42a.74.74,0,0,1-.74.73,1.84,1.84,0,1,0,0,3.69.74.74,0,0,1,.74.74v3.55A.74.74,0,0,1,18.57,16.86ZM2.17,15.39H17.83V13.23a3.31,3.31,0,0,1,0-6.46V4.61H2.17V6.77a3.31,3.31,0,0,1,0,6.46Z",
    })];
    return react.createElement("svg", keyValueList(props_2, 1), ...children_2);
}

export function Icons_TicketLink(label, onClick) {
    const children = [Icons_TicketSvg(ofArray([new CSSProp(189, ["1.3em"]), new CSSProp(382, ["sub"]), new CSSProp(225, ["5px"])])), label];
    return react.createElement("a", {
        onClick: onClick,
    }, ...children);
}

export function Icons_TicketErstellenLink(onClick) {
    return Icons_TicketLink("Ticket erstellen", onClick);
}

export function Icons_CheckboxChecked(customStyle) {
    const props_2 = [["viewBox", "0 0 448 512"], ["style", keyValueList(customStyle, 1)]];
    const children_2 = [react.createElement("path", {
        d: "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z",
    })];
    return react.createElement("svg", keyValueList(props_2, 1), ...children_2);
}

export function Icons_CheckboxUnchecked(customStyle) {
    const props_2 = [["viewBox", "0 0 448 512"], ["style", keyValueList(customStyle, 1)]];
    const children_2 = [react.createElement("path", {
        d: "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z",
    })];
    return react.createElement("svg", keyValueList(props_2, 1), ...children_2);
}

export function Icons_Download(customStyle) {
    const props_2 = [["viewBox", "0 0 512 512"], ["style", keyValueList(customStyle, 1)]];
    const children_2 = [react.createElement("path", {
        d: "M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z",
    })];
    return react.createElement("svg", keyValueList(props_2, 1), ...children_2);
}

export function Icons_DrawerSend(customStyle) {
    const props_6 = [new HTMLAttr(65, ["drawer-send"]), ["viewBox", "0 0 17 16"], ["fill", "none"], ["style", keyValueList(customStyle, 1)]];
    const children_6 = [react.createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12.2754 10C11.5693 11.2368 10.2543 12.0003 8.83008 12.0003C7.40585 12.0003 6.0909 11.2368 5.38474 10H2.83008C2.27779 10 1.83008 10.4477 1.83008 11V14C1.83008 14.5523 2.27779 15 2.83008 15H14.8301C15.3824 15 15.8301 14.5523 15.8301 14V11C15.8301 10.4477 15.3824 10 14.8301 10H12.2754Z",
        stroke: "#EF7B0A",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
    }), react.createElement("path", {
        d: "M7.83008 8V7C7.83008 4.79086 9.62094 3 11.8301 3H14.3301",
        stroke: "#EF7B0A",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
    }), react.createElement("path", {
        d: "M11.8301 1L14.3301 3L11.8301 5",
        stroke: "#EF7B0A",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
    })];
    return react.createElement("svg", keyValueList(props_6, 1), ...children_6);
}

export function Icons_DownloadLink(text, href) {
    const children = [Icons_Download(ofArray([new CSSProp(189, ["1.3em"]), new CSSProp(382, ["sub"]), new CSSProp(225, ["5px"])])), toText(printf("%s herunterladen"))(text)];
    return react.createElement("a", {
        href: href,
    }, ...children);
}

export function Icons_DownloadLink2(text, onClick) {
    const children = [Icons_Download(ofArray([new CSSProp(189, ["1.3em"]), new CSSProp(382, ["sub"]), new CSSProp(225, ["5px"])])), toText(printf("%s herunterladen"))(text)];
    return react.createElement("a", {
        onClick: onClick,
    }, ...children);
}

export function Icons_DrawerSend2(text, onClick) {
    const children = [Icons_DrawerSend(ofArray([new CSSProp(189, ["1.3em"]), new CSSProp(382, ["sub"]), new CSSProp(225, ["5px"])])), `${text}`];
    return react.createElement("a", {
        onClick: onClick,
    }, ...children);
}

export function orangeCheckbox(ischecked, onclick) {
    const props = [new HTMLAttr(65, ["orangeCheckbox " + (ischecked ? "is-active" : "")]), new DOMAttr(40, [onclick])];
    const children = toList(delay(() => (ischecked ? singleton(Icons_CheckboxChecked(ofArray([new CSSProp(395, ["1em"]), new CSSProp(226, ["5px"]), new CSSProp(225, ["5px"])]))) : singleton(Icons_CheckboxUnchecked(ofArray([new CSSProp(395, ["1em"]), new CSSProp(226, ["5px"]), new CSSProp(225, ["5px"])]))))));
    return react.createElement("div", keyValueList(props, 1), ...children);
}

function disabeldCheckboxWithTooltip(text, onclick, multiline) {
    const props = toList(delay(() => append(singleton(new HTMLAttr(65, ["orangeCheckbox is-disabeld"])), delay(() => append(singleton(new DOMAttr(40, [onclick])), delay(() => (!(isTouch) ? append(singleton(new HTMLAttr(65, ["orangeCheckbox is-disabeld tooltip " + (multiline ? "is-tooltip-multiline" : "")])), delay(() => singleton(["data-tooltip", text]))) : empty())))))));
    const children = [Icons_CheckboxUnchecked(ofArray([new CSSProp(395, ["1em"]), new CSSProp(226, ["5px"]), new CSSProp(225, ["5px"])]))];
    return react.createElement("div", keyValueList(props, 1), ...children);
}

export function disabeldCheckboxWithTooltipSingleline(text, onclick) {
    return disabeldCheckboxWithTooltip(text, onclick, false);
}

export function disabeldCheckboxWithTooltipMultiline(text, onclick) {
    return disabeldCheckboxWithTooltip(text, onclick, true);
}

export function switch$(isChecked, onChange, nr) {
    return switch$_1(ofArray([new Option(11, ["is-info"]), new Option(6, [isChecked]), new Option(10, [(ev) => {
        onChange(ev.target.checked);
    }]), new Option(12, ["switch" + nr])]), empty_1());
}

export function regularSwitch(isChecked, isDisabled, onChange, label, nr, switchProperties) {
    return switch$_1(toList(delay(() => append(singleton(new Option(2, [])), delay(() => append(singleton(new Option(6, [isChecked])), delay(() => append(singleton(new Option(7, [isDisabled])), delay(() => append(singleton(new Option(0, [CustomColors_bfsOrange])), delay(() => append(singleton(new Option(10, [(ev) => {
        onChange(ev.target.checked);
    }])), delay(() => append(singleton(new Option(12, ["switch" + nr])), delay(() => switchProperties)))))))))))))), singleton_1(react.createElement("div", {}, label)));
}

export function checkbox(isChecked, onChange, nr) {
    return orangeCheckbox(isChecked, (_arg) => {
        onChange(!isChecked);
    });
}

//# sourceMappingURL=ViewParts.fs.js.map
